import { render, staticRenderFns } from "./EscolhaEdicao.vue?vue&type=template&id=1e3f7c49"
import script from "./EscolhaEdicao.vue?vue&type=script&setup=true&lang=js"
export * from "./EscolhaEdicao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports